module.exports = __webpack_public_path__ + "img/template.444d3fa7.png";